module.exports = __webpack_public_path__ + "static/media/deploy_arrow.0afc49f2.svg";